export default __webpack_public_path__ + "static/media/wf-isf-perspectives-urban-forests_767x577.54ca3ded.jpg";